import React, { useState } from "react";
import {
  TextField,
  MenuItem,
  RadioGroup,
  Radio,
  Tooltip,
  FormControlLabel,
} from "@material-ui/core";
import { connect } from "react-redux";
import {
  updateForm,
  testUserData,
  testCalculatorData,
  setAge1,
  setAge2,
  setBirthday1,
  setBirthday2,
  setTotalIncome,
  setNon401IraIncome,
  generateBudget,
  generateWages,
  generateSS,
  generatePrivatePension,
  generatePublicPension,
  setInvestmentIncome,
  generateShortfall,
  generateYears,
  setMarriedIncome,
  calculateNeeded,
} from "../state/calculator";
import { bindActionCreators } from "redux";
import { makeStyles } from "@material-ui/core/styles";
import LoaderButton from "./LoaderButton";
import { Grid, Card } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: "40px",
    fontSize: "20px",
    display: "flex",
    textAlign: "center",
    color: theme.palette.text.secondary,
    justifyContent: "space-evenly",
    alignItems: "center",
    color: "#00303F",
  },
  card: {
    border: "100px solid #00303F",
    marginTop: -50,
    marginRight: -50,
    marginLeft: -60,
  },
}));

function Profile(props) {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const fields = props.redux;

  const formStyle = {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    fontWeight: "bold",
    paddingBottom: 5,
    paddingRight: 10,
    paddingLeft: 10,
  };

  const handleChange = (event) => {
    const value = event.target.value;
    console.log(event.target);
    switch (event.target.name) {
      case "UPDATE_FORM":
        let obj = { id: event.target.id, value: event.target.value };
        // we need to add in a check when we submit the data to the database that retireAgeS1 value should be >= 62

        if (event.target.id === "retireAgeS1") {
          if (event.target.value == 6 || event.target.value == 7) {
            props.updateForm(obj);
          } else if (event.target.value < 62) {
            alert("Social Security must be at least 62 years old.");
          } else {
            props.updateForm(obj);
          }
        } else {
          props.updateForm(obj);
        }
        break;
      case "secondHouse":
        let houseBoolean;
        if (event.target.value === "false") {
          houseBoolean = false;
        } else {
          houseBoolean = true;
        }
        let houseObj = { id: event.target.name, value: houseBoolean };
        props.updateForm(houseObj);
        break;
      case "justWagesS1":
        let tempBoolean;
        if (event.target.value === "false") {
          tempBoolean = false;
        } else {
          tempBoolean = true;
        }
        let justWagesObj = { id: event.target.name, value: tempBoolean };
        console.log(justWagesObj);
        props.updateForm(justWagesObj);

        if (tempBoolean === true) {
          props.updateForm({
            id: "stashedRetireAgeS1",
            value: fields.ageWagesStopS1,
          });
          props.updateForm({ id: "ageWagesStopS1", value: "120" });
        } else {
          props.updateForm({ id: "stashedRetireAgeS1", value: "120" });
          props.updateForm({
            id: "ageWagesStopS1",
            value: fields.stashedRetireAgeS1,
          });
        }

        break;
      case "both":
        let tempBool;
        if (event.target.value === "false") {
          tempBool = false;
        } else {
          tempBool = true;
        }
        let justBothObj = { id: event.target.name, value: tempBool };
        props.updateForm(justBothObj);
        break;
      case "healthInsurance":
        let tempBool2;
        if (event.target.value === "false") {
          tempBool2 = false;
        } else {
          tempBool2 = true;
        }
        let healthInsuranceObj = { id: event.target.name, value: tempBool2 };
        props.updateForm(healthInsuranceObj);
        break;
      case "SET_BIRTHDAY1":
        let birthdayObj = { id: event.target.id, value: event.target.value };
        console.log(birthdayObj);
        props.updateForm(birthdayObj);
        props.setAge1();
        break;
      case "SET_BIRTHDAY2":
        let birthday2Obj = { id: event.target.id, value: event.target.value };
        props.updateForm(birthday2Obj);
        props.setAge2();
        break;
      default:
        return value;
    }
  };

  const handleFieldChange = (event) => {
    if (event.target.id === undefined) {
      setField(event.target.name, event.target.value);
    } else {
      setField(event.target.id, event.target.value);
    }
  };

  const setField = (id, value) => {
    let obj = { id: id, value: value };
    props.updateForm(obj);
  };

  function validateForm() {
    let value =
      fields.currentStreetAddress.length > 0 &&
      fields.currentCityAddress.length > 0 &&
      fields.currentStateAddress.length > 0 &&
      fields.currentZipAddress.length > 0 &&
      fields.firstName.length > 0 &&
      fields.lastName.length > 0 &&
      fields.userAgreement.length > 0 &&
      fields.homePayment.length > 0 &&
      fields.userBAddress.length > 0 &&
      fields.subscriptionPeriod.length > 0 &&
      fields.email.length > 0 &&
      fields.password.length > 0 &&
      fields.homeInsurance.length > 0 &&
      fields.propertyTax.length > 0 &&
      fields.lengthOfLoan.length > 0 &&
      fields.mortgageDownPayment.length > 0 &&
      fields.mortgageInterestRate.length > 0 &&
      fields.targetSavings.length > 0 &&
      fields.addlExpenses.length > 0 &&
      fields.secondHouse.length > 0 &&
      fields.europeanDataSubject.length > 0 &&
      fields.schoolDistrict.length > 0;

    if (value === true) {
      setDisabled(false);
    }
    return value;
  }

  function addUserToDB(user_id) {
    let SecondHouse;
    if (props.redux.secondHouse === true) {
      SecondHouse = true;
    } else {
      SecondHouse = false;
    }
    let body = {
      user_token: user_id,
      currentCityAddress: fields.currentCityAddress,
      currentStateAddress: fields.currentStateAddress,
      currentStreetAddress: fields.currentStreetAddress,
      currentZipAddress: fields.currentZipAddress,
      email: fields.email,
      firstName: fields.firstName,
      lastName: fields.lastName,
      homeInsurance: fields.homeInsurance,
      homePayment: fields.homePayment,
      lengthOfLoan: parseInt(fields.lengthOfLoan, 10),
      mortgageDownPayment: parseInt(fields.mortgageDownPayment, 10) / 100,
      mortgageInterestRate: parseInt(fields.mortgageInterestRate, 10) / 100,
      password: fields.password,
      propertyTax: fields.propertyTax,
      subscriptionPeriod: fields.subscriptionPeriod,
      targetSavings: fields.targetSavings,
      userAgreement: "yes",
      userBAddress: fields.userBAddress,
      addlExpenses: fields.addlExpenses,
      // review this - needs to be 'S' or 'P'
      secondHouse: SecondHouse,
      // we need to address european data subject
      europeanDataSubject: "no",
      schoolDistrict: fields.schoolDistrict,
      RecordTStamp: Date.now().toString(),
    };
    fetch(`http://${process.env.REACT_APP_STAGE}/users`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
    })
      .then((response) => response.text())
      .then((data) => {
        // let parsedData = JSON.parse(data);
        console.log("USER POST :", data);
        return data;
      });
  }

  async function handleSubmit() {
    setIsLoading(true);
    setField(
      "userBAddress",
      `${fields.currentStreetAddress}, ${fields.currentCityAddress}, ${fields.currentStateAddress} ${fields.currentZipAddress}`
    );
    let localUserId = localStorage.getItem("user");
    let jsonLocalID = JSON.parse(localUserId);
    let id;
    if (!jsonLocalID.user) {
      id = jsonLocalID.id;
    } else {
      id = jsonLocalID.user.id;
    }
    try {
      addUserToDB(id);
      setIsLoading(false);
    } catch (e) {
      alert(e.message);
      setIsLoading(false);
    }
  }

  return (
    <div style={{ marginLeft: 12, marginRight: 12 }}>
      <form onSubmit={handleSubmit}>
        <div style={{ marginTop: 40 }}>
          <h3>Your Profile and Retirement Goals</h3>
          <p>
            Please fill out the form below so that we can generate your
            personalized affordability insights.
          </p>
        </div>
        <React.Fragment>
          <h3
            style={{
              display: "flex",
              alignSelf: "start",
              marginTop: 40,
              marginLeft: 12,
            }}
          >
            Current Residence and Personal Details
          </h3>

          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
            className={classes.paper}
          >
            <div style={formStyle}>
              <span style={{ alignSelf: "start" }}>Address</span>
              <TextField
                variant="outlined"
                id="currentStreetAddress"
                type="text"
                value={fields.currentStreetAddress}
                onChange={handleFieldChange}
              />
              <br />
            </div>

            <div style={formStyle}>
              <span style={{ alignSelf: "start" }}>City</span>
              <TextField
                variant="outlined"
                id="currentCityAddress"
                type="text"
                value={fields.currentCityAddress}
                onChange={handleFieldChange}
              />
              <br />
            </div>
            <div style={formStyle}>
              <span style={{ alignSelf: "start" }}>State</span>
              <TextField
                variant="outlined"
                id="currentStateAddress"
                type="text"
                value={fields.currentStateAddress}
                onChange={handleFieldChange}
              />
              <br />
            </div>
            <div style={formStyle}>
              <span style={{ alignSelf: "start" }}>Zip Code</span>
              <TextField
                variant="outlined"
                id="currentZipAddress"
                type="number"
                value={fields.currentZipAddress}
                onChange={handleFieldChange}
              />
              <br />
            </div>
          </Grid>

          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
            className={classes.paper}
          >
            <div style={formStyle}>
              <span style={{ alignSelf: "start" }}>Home Payment (Monthly)</span>
              <TextField
                id="homePayment"
                type="number"
                variant="outlined"
                value={fields.homePayment}
                onChange={handleFieldChange}
              />
            </div>
            <div style={formStyle}>
              <span style={{ alignSelf: "start" }}>
                Property Insurance (Monthly)
              </span>
              <TextField
                variant="outlined"
                id="homeInsurance"
                type="number"
                value={fields.homeInsurance}
                onChange={handleFieldChange}
              />
            </div>
            <div style={formStyle}>
              <span style={{ alignSelf: "start" }}>Property Tax (Monthly)</span>
              <TextField
                variant="outlined"
                id="propertyTax"
                type="number"
                value={fields.propertyTax}
                onChange={handleFieldChange}
              />
            </div>
            {/* <div style={formStyle}>
                <span style={{ alignSelf: "start" }}>School District</span>
                <TextField
                  variant="outlined"
                  id="schooldistrict"
                  type="text"
                  value={fields.schoolDistrict}
                  onChange={handleFieldChange}
                />
                <br />
              </div> */}
            {/* <div style={formStyle}>
                <span style={{ alignSelf: "start" }}>County</span>
                <TextField
                  variant="outlined"
                  id="county"
                  type="text"
                  value={fields.county}
                  onChange={handleFieldChange}
                />
                <br />
              </div> */}
          </Grid>

          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
            className={classes.paper}
          >
            {/* Birthday, Tax Filing Status Goes Here */}
            <div style={formStyle}>
              <span style={{ alignSelf: "start" }}>Birthday 1</span>
              <TextField
                id="birthdayS1"
                type="text"
                onChange={handleChange}
                name="SET_BIRTHDAY1"
                value={fields.birthdayS1}
                placeholder="MM-YYYY"
                variant="outlined"
              />
            </div>
            <div style={formStyle}>
              <span style={{ alignSelf: "start" }}>Birthday 2</span>
              <TextField
                id="birthdayS2"
                type="text"
                onChange={handleChange}
                name="SET_BIRTHDAY2"
                value={fields.birthdayS2}
                placeholder="MM-YYYY"
                variant="outlined"
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <span>Tax Filing Status</span>
              <RadioGroup
                id="numSub"
                defaultValue="1"
                aria-label="dataSubjects"
                name="dataSubjects"
                value={fields.both}
                onChange={handleChange}
              >
                <FormControlLabel
                  className="MuiRadio-colorSecondary"
                  value={false}
                  control={<Radio />}
                  label="Single"
                  name="both"
                />
                <FormControlLabel
                  className="MuiRadio-colorSecondary"
                  value={true}
                  control={<Radio />}
                  label="Couple"
                  name="both"
                />
              </RadioGroup>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <span>Health Insurance</span>
              <RadioGroup
                id="healthInsurance"
                defaultValue="1"
                aria-label="healthInsurance"
                name="healthInsurance"
                value={fields.healthInsurance}
                onChange={handleChange}
              >
                <FormControlLabel
                  className="MuiRadio-colorSecondary"
                  value={false}
                  control={<Radio />}
                  label="No Insurance"
                  name="healthInsurance"
                />
                <FormControlLabel
                  className="MuiRadio-colorSecondary"
                  value={true}
                  control={<Radio />}
                  label="Has Insurance"
                  name="healthInsurance"
                />
              </RadioGroup>
            </div>
          </Grid>
        </React.Fragment>

        <React.Fragment>
          <h3
            style={{
              display: "flex",
              alignSelf: "start",
              marginTop: 40,
              marginLeft: 12,
            }}
          >
            Goals/Future
          </h3>
          <React.Fragment>
            <Grid
              container
              direction="row"
              justify="flex-start"
              alignItems="center"
              className={classes.paper}
            >
              <div style={formStyle}>
                <span
                  className="userInputLabel"
                  style={{
                    display: "flex",
                    alignSelf: "start",
                    justifyContent: "start",
                  }}
                >
                  Budget (Retirement)
                </span>
                <TextField
                  id="targetTaxableBudgetS1"
                  className="userInputBox"
                  type="text"
                  name="UPDATE_FORM"
                  value={fields.targetTaxableBudgetS1}
                  onChange={handleChange}
                />
              </div>
              <div style={formStyle}>
                <span style={{ alignSelf: "start" }}>Target Savings</span>
                <TextField
                  variant="outlined"
                  id="targetSavings"
                  type="number"
                  value={fields.targetSavings}
                  onChange={handleFieldChange}
                />
              </div>
              <div style={formStyle}>
                <span style={{ alignSelf: "start" }}>
                  Living expenses outside of mortgage
                </span>
                <TextField
                  variant="outlined"
                  id="addlExpenses"
                  type="number"
                  value={fields.addlExpenses}
                  onChange={handleFieldChange}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <span>New Property</span>
                <RadioGroup
                  id="secondHouse"
                  name="UPDATE_FORM"
                  value={fields.secondHouse}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    className="MuiRadio-colorSecondary"
                    value={false}
                    control={<Radio />}
                    label="Primary Residence"
                    name="secondHouse"
                  />
                  <FormControlLabel
                    className="MuiRadio-colorSecondary"
                    value={true}
                    control={<Radio />}
                    label="Secondary Residence"
                    name="secondHouse"
                  />
                </RadioGroup>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <span>Just Wages</span>
                <RadioGroup
                  id="justWages"
                  value={fields.justWagesS1}
                  aria-label="justWages"
                  onChange={handleChange}
                >
                  <FormControlLabel
                    className="MuiRadio-colorSecondary"
                    value={true}
                    control={<Radio />}
                    label="Yes"
                    name="justWagesS1"
                  />
                  <FormControlLabel
                    className="MuiRadio-colorSecondary"
                    value={false}
                    control={<Radio />}
                    label="No"
                    name="justWagesS1"
                  />
                </RadioGroup>
              </div>
            </Grid>
          </React.Fragment>
          <React.Fragment>
            <Tooltip title="The mortgage information captured in this section will apply to the analysis for all the properties added to your database.">
              <h3
                style={{
                  display: "flex",
                  alignSelf: "start",
                  marginTop: 40,
                  marginLeft: 12,
                }}
              >
                Desired Mortgage (i)
              </h3>
            </Tooltip>
            <Grid
              container
              direction="row"
              alignItems="center"
              className={classes.paper}
            >
              <div style={formStyle}>
                <span style={{ alignSelf: "start" }}>
                  Preferred Down Payment (%)
                </span>
                <TextField
                  variant="outlined"
                  id="mortgageDownPayment"
                  type="number"
                  value={fields.mortgageDownPayment}
                  onChange={handleFieldChange}
                />
              </div>
              <div style={formStyle}>
                <span style={{ alignSelf: "start" }}>
                  Target Interest Rate %
                </span>
                <TextField
                  variant="outlined"
                  id="mortgageInterestRate"
                  type="number"
                  value={fields.mortgageInterestRate}
                  onChange={handleFieldChange}
                />
              </div>
              <div style={formStyle}>
                <span style={{ alignSelf: "start" }}>
                  How many years for your NEW mortgage?
                </span>
                <TextField
                  variant="outlined"
                  id="lengthOfLoan"
                  type="number"
                  value={fields.lengthOfLoan}
                  onChange={handleFieldChange}
                />
              </div>
            </Grid>
          </React.Fragment>
          <LoaderButton loading={isLoading} onClick={() => handleSubmit()}>
            Save Profile
          </LoaderButton>
        </React.Fragment>
      </form>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    redux: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateForm: (formData) => updateForm(formData),
      testUserData: () => testUserData(),
      setBirthday1: (params) => setBirthday1(params),
      setBirthday2: (params) => setBirthday2(params),
      setAge1: () => setAge1(),
      setAge2: () => setAge2(),
      setTotalIncome: () => setTotalIncome(),
      setMarriedIncome: () => setMarriedIncome(),
      setNon401IraIncome: () => setNon401IraIncome(),
      generateBudget: () => generateBudget(),
      generateWages: () => generateWages(),
      generateSS: () => generateSS(),
      generatePrivatePension: () => generatePrivatePension(),
      generatePublicPension: () => generatePublicPension(),
      setInvestmentIncome: () => setInvestmentIncome(),
      generateShortfall: () => generateShortfall(),
      generateYears: (years) => generateYears(years),
      calculateNeeded: () => calculateNeeded(),
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
